module.exports = __webpack_public_path__ + "static/media/strength-and-asset.0b6ffe57.svg";